import { runoutTimes } from '@constants/orderDispatch'
import moment from 'moment'

export const filterByRunoutTime = (rowDispatchEnd, selectedOptions) => {
  const now = moment().local().add(12, 'h')
  const runoutTime = moment(rowDispatchEnd).local()
  const add1day = moment().local().add(24, 'h')
  const add3Days = moment().local().add(3, 'd')
  const add1week = moment().local().add(7, 'd')

  switch (selectedOptions) {
    case runoutTimes.HALFDAY:
      return runoutTime < now

    case runoutTimes.DAY:
      return runoutTime < add1day

    case runoutTimes.THREEDAYS:
      return runoutTime < add3Days

    case runoutTimes.WEEK:
      return runoutTime < add1week

    default:
      return true
  }
}
